<template>
  <div class="mx-status-tabs" :style="wrapStyle">
    <div>
      <button
        v-for="tab in normalizedList"
        :key="tab.value"
        type="button"
        class="mx-status-tab"
        :class="{ active: isActive(tab.value), disabled: tab.disabled }"
        :disabled="tab.disabled"
        @click="handleClick(tab)"
      >
        <span>{{ tab.label }}</span>
        <span v-if="showCount(tab)" class="mx-status-tab-count"
          >({{ tab.count }})</span
        >
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MXStatusTabs',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    height: {
      type: String,
      default: '40px',
    },
    innerPadding: {
      type: String,
      default: '20px',
    },
    gap: {
      type: String,
      default: '32px',
    },
  },
  computed: {
    normalizedList() {
      return this.list.filter((item) => item && item.label !== undefined)
    },
    wrapStyle() {
      return {
        height: this.height,
        padding: `0 ${this.innerPadding}`,
        gap: this.gap,
      }
    },
  },
  methods: {
    isActive(value) {
      return this.value === value
    },
    showCount(tab) {
      return tab.count !== undefined && tab.count !== null
    },
    handleClick(tab) {
      if (tab.disabled || this.isActive(tab.value)) return
      this.$emit('input', tab.value)
      this.$emit('change', tab.value, tab)
    },
  },
}
</script>

<style lang="less" scoped>
.mx-status-tabs {
  flex: 0 0 auto;
  background: #fff;
  > div {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    border-bottom: 1px solid #eef1f6;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 32px;
    padding: 0 16px;
  }
}

.mx-status-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  height: 100%;
  padding: 0;
  color: #272e3b;
  font-size: 14px;
  line-height: inherit;
  white-space: nowrap;
  cursor: pointer;
  background: transparent;
  border: 0;
  outline: none;

  &.active {
    color: #1456f0;

    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 3px;
      content: '';
      background: #1456f0;
      border-radius: 3px 3px 0 0;
    }
  }

  &.disabled {
    color: #b8bfcc;
    cursor: not-allowed;
  }
}

.mx-status-tab-count {
  margin-left: 2px;
}
</style>

